module.exports = __webpack_public_path__ + "img/bottom_people_001.87714f01.svg";